const copyTextToClipboard = async str => {
  // document.execCommand('copy') is no longer recommended. It was deprecated
  // using async Clipboard API
  try {
    await navigator.clipboard.writeText(str);
  } catch (err) {
    console.trace('Failed to copy: ', err);
  }
};
export default copyTextToClipboard;
